import { useEffect, useRef } from 'react';

import { useAppDispatch } from '@/store/hooks';
import { loadWorkingSession } from '@/store/slices/project';

type LoadOptions = {
  returnStateIfExists?: boolean;
};

const useLoadSession = (sessionId?: number | null, options?: LoadOptions) => {
  const dispatch = useAppDispatch();

  const fetching = useRef<number | null>(null);

  useEffect(() => {
    (async () => {
      try {
        if (sessionId && sessionId !== fetching.current) {
          fetching.current = sessionId;
          await dispatch(
            loadWorkingSession({
              sessionId: sessionId,
              returnStoreStateIfExists: options?.returnStateIfExists ?? true,
            })
          );
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [dispatch, options, sessionId]);
};

export default useLoadSession;
